import { render, staticRenderFns } from "./AdminSQLSync.vue?vue&type=template&id=10207575&scoped=true"
import script from "./AdminSQLSync.vue?vue&type=script&lang=js"
export * from "./AdminSQLSync.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./AdminSQLSync.vue?vue&type=style&index=1&id=10207575&prod&lang=css"
import style2 from "./AdminSQLSync.vue?vue&type=style&index=2&id=10207575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10207575",
  null
  
)

export default component.exports